<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 10000">
    <app-toaster />
</div>
<router-outlet />
 

